import type { UserRole } from '@/lib/api/schemas';

import { AppRoutes } from '@/constants/routes';

// middleware/roles.ts
export default defineNuxtRouteMiddleware(async(to) => {
  const auth = useAuthStore();
  if (!import.meta.client) {
    return;
  }
  if (!to.meta.requiresAuth) {
    return;
  }
  await auth.bootstrap();
  if (!auth.isAuthenticated) {
    return navigateTo({
      path: AppRoutes.AUTH_LOGIN,
      query: { redirect: to.fullPath },
    });
  }
  const allowedRoles = to.meta.allowedRoles as UserRole[] | undefined;
  if (to.meta.allowedRoles && auth.user?.role && !allowedRoles?.includes(auth.user.role)) {
    return navigateTo(AppRoutes.FORBIDDEN);
  }
});
